import { render, staticRenderFns } from "./ClinicPageFilterPane.vue?vue&type=template&id=f985a9c6"
import script from "./ClinicPageFilterPane.vue?vue&type=script&lang=js"
export * from "./ClinicPageFilterPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports